<ng-container *ngIf="(inputConfig$ | async) as inputConfig">
  <div class="flex align-items-center">
    <span style="white-space: nowrap" class="m-0">{{prefixValue}}</span>
    <!-- TODO - number ne pokazuje dobro readonly -->
    <ng-container *ngIf="!inputConfig.readOnly">
      <p-inputNumber
        #redoslijedInputBox
        [readonly]="inputConfig.readOnly"
        name="orderFormControl"
        [formControl]="orderFormControl"
        [disabled]="inputConfig.disabled"
        inputId="orderFormControl"
        [useGrouping]="false"
        placeholder="Redoslijed"
        (onInput)="onOrderInput($event)"
      >
      </p-inputNumber>
    </ng-container>
    <span *ngIf="inputConfig.readOnly">{{orderFormControl.value}}</span>
  </div>
  <ntap-show-form-errors [control]="formControl"></ntap-show-form-errors>
</ng-container>
<p-messages [value]="warnMessage" [enableService]="false" [closable]="false"></p-messages>
